import { SfSelectOption } from 'ngx-smart-form';

export const COUNTRIES = [
  { view: 'Afghanistan', value: 300, sigla2: 'AF', sigla3: 'AFG', id: 'AFG' },
  { view: 'Albania', value: 300, sigla2: 'AL', sigla3: 'ALB', id: 'ALB' },
  { view: 'Algeria', value: 300, sigla2: 'DZ', sigla3: 'DZA', id: 'DZA' },
  {
    view: 'American Samoa',
    value: 300,
    sigla2: 'AS',
    sigla3: 'ASM',
    id: 'ASM',
  },
  { view: 'Andorra', value: 300, sigla2: 'AD', sigla3: 'AND', id: 'AND' },
  { view: 'Angola', value: 300, sigla2: 'AO', sigla3: 'AGO', id: 'AGO' },
  { view: 'Anguilla', value: 300, sigla2: 'AI', sigla3: 'AIA', id: 'AIA' },
  {
    view: 'Antigua e Barbuda',
    value: 300,
    sigla2: 'AG',
    sigla3: 'ATG',
    id: 'ATG',
  },
  { view: 'Argentina', value: 300, sigla2: 'AR', sigla3: 'ARG', id: 'ARG' },
  { view: 'Armenia', value: 300, sigla2: 'AM', sigla3: 'ARM', id: 'ARM' },
  { view: 'Aruba', value: 300, sigla2: 'AW', sigla3: 'ABW', id: 'ABW' },
  { view: 'Australia', value: 50, sigla2: 'AU', sigla3: 'AUS', id: 'AUS' },
  { view: 'Austria', value: 20, sigla2: 'AT', sigla3: 'AUT', id: 'AUT' },
  { view: 'Azerbaijan', value: 300, sigla2: 'AZ', sigla3: 'AZE', id: 'AZE' },
  { view: 'Bahamas', value: 300, sigla2: 'BS', sigla3: 'BHS', id: 'BHS' },
  { view: 'Bahrain', value: 300, sigla2: 'BH', sigla3: 'BHR', id: 'BHR' },
  { view: 'Bangladesh', value: 300, sigla2: 'BD', sigla3: 'BGD', id: 'BGD' },
  { view: 'Barbados', value: 300, sigla2: 'BB', sigla3: 'BRB', id: 'BRB' },
  { view: 'Belarus', value: 300, sigla2: 'BY', sigla3: 'BLR', id: 'BLR' },
  { view: 'Belgium', value: 20, sigla2: 'BE', sigla3: 'BEL', id: 'BEL' },
  { view: 'Belize', value: 300, sigla2: 'BZ', sigla3: 'BLZ', id: 'BLZ' },
  { view: 'Benin', value: 300, sigla2: 'BJ', sigla3: 'BEN', id: 'BEN' },
  { view: 'Bermuda', value: 300, sigla2: 'BM', sigla3: 'BMU', id: 'BMU' },
  { view: 'Bhutan', value: 300, sigla2: 'BT', sigla3: 'BTN', id: 'BTN' },
  { view: 'Bolivia', value: 300, sigla2: 'BO', sigla3: 'BOL', id: 'BOL' },
  {
    view: 'Bosnia ed Erzegovina',
    value: 300,
    sigla2: 'BA',
    sigla3: 'BIH',
    id: 'BIH',
  },
  { view: 'Botswana', value: 300, sigla2: 'BW', sigla3: 'BWA', id: 'BWA' },
  { view: 'Brazil', value: 300, sigla2: 'BR', sigla3: 'BRA', id: 'BRA' },
  {
    view: 'British Virgin Islands',
    value: 300,
    sigla2: 'VG',
    sigla3: 'VGB',
    id: 'VGB',
  },
  { view: 'Brunei', value: 300, sigla2: 'BN', sigla3: 'BRN', id: 'BRN' },
  { view: 'Bulgaria', value: 20, sigla2: 'BG', sigla3: 'BGR', id: 'BGR' },
  { view: 'Burkina Faso', value: 300, sigla2: 'BF', sigla3: 'BFA', id: 'BFA' },
  { view: 'Burundi', value: 300, sigla2: 'BI', sigla3: 'BDI', id: 'BDI' },
  { view: 'Capo Verde', value: 300, sigla2: 'CV', sigla3: 'CPV', id: 'CPV' },
  { view: 'Cambogia', value: 300, sigla2: 'KH', sigla3: 'KHM', id: 'KHM' },
  { view: 'Camerun', value: 300, sigla2: 'CM', sigla3: 'CMR', id: 'CMR' },
  { view: 'Canada', value: 50, sigla2: 'CA', sigla3: 'CAN', id: 'CAN' },
  { view: 'Isole Cayman', value: 300, sigla2: 'KY', sigla3: 'CYM', id: 'CYM' },
  {
    view: 'Repubblica Centrafricana',
    value: 300,
    sigla2: 'CF',
    sigla3: 'CAF',
    id: 'CAF',
  },
  { view: 'Chad', value: 300, sigla2: 'TD', sigla3: 'TCD', id: 'TCD' },
  { view: 'Cile', value: 300, sigla2: 'CL', sigla3: 'CHL', id: 'CHL' },
  { view: 'Cina', value: 300, sigla2: 'CN', sigla3: 'CHN', id: 'CHN' },
  { view: 'Colombia', value: 300, sigla2: 'CO', sigla3: 'COL', id: 'COL' },
  { view: 'Comore', value: 300, sigla2: 'KM', sigla3: 'COM', id: 'COM' },
  {
    view: 'Repubblica del Congo',
    value: 300,
    sigla2: 'CG',
    sigla3: 'COG',
    id: 'COG',
  },
  { view: 'Isole Cook', value: 300, sigla2: 'CK', sigla3: 'COK', id: 'COK' },
  { view: 'Costa Rica', value: 300, sigla2: 'CR', sigla3: 'CRI', id: 'CRI' },
  {
    view: "Costa d'Avorio",
    value: 300,
    sigla2: 'CI',
    sigla3: 'CIV',
    id: 'CIV',
  },
  { view: 'Croazia', value: 20, sigla2: 'HR', sigla3: 'HRV', id: 'HRV' },
  { view: 'Cuba', value: 300, sigla2: 'CU', sigla3: 'CUB', id: 'CUB' },
  { view: 'Curaçao', value: 300, sigla2: 'CW', sigla3: 'CUW', id: 'CUW' },
  { view: 'Cipro', value: 20, sigla2: 'CY', sigla3: 'CYP', id: 'CYP' },
  {
    view: 'Repubblica Ceca',
    value: 20,
    sigla2: 'CZ',
    sigla3: 'CZE',
    id: 'CZE',
  },
  {
    view: 'Repubblica Democratica del Congo',
    value: 300,
    sigla2: 'CD',
    sigla3: 'COD',
    id: 'COD',
  },
  { view: 'Danimarca', value: 20, sigla2: 'DK', sigla3: 'DNK', id: 'DNK' },
  { view: 'Gibuti', value: 300, sigla2: 'DJ', sigla3: 'DJI', id: 'DJI' },
  { view: 'Dominica', value: 300, sigla2: 'DM', sigla3: 'DMA', id: 'DMA' },
  {
    view: 'Repubblica Dominicana',
    value: 300,
    sigla2: 'DO',
    sigla3: 'DOM',
    id: 'DOM',
  },
  { view: 'Ecuador', value: 300, sigla2: 'EC', sigla3: 'ECU', id: 'ECU' },
  { view: 'Egitto', value: 300, sigla2: 'EG', sigla3: 'EGY', id: 'EGY' },
  { view: 'El Salvador', value: 300, sigla2: 'SV', sigla3: 'SLV', id: 'SLV' },
  {
    view: 'Guinea Equatoriale',
    value: 300,
    sigla2: 'GQ',
    sigla3: 'GNQ',
    id: 'GNQ',
  },
  { view: 'Eritrea', value: 300, sigla2: 'ER', sigla3: 'ERI', id: 'ERI' },
  { view: 'Estonia', value: 20, sigla2: 'EE', sigla3: 'EST', id: 'EST' },
  { view: 'eSwatini', value: 300, sigla2: 'SZ', sigla3: 'SWZ', id: 'SWZ' },
  { view: 'Etiopia', value: 300, sigla2: 'ET', sigla3: 'ETH', id: 'ETH' },
  {
    view: 'Isole Falkland',
    value: 300,
    sigla2: 'FK',
    sigla3: 'FLK',
    id: 'FLK',
  },
  { view: 'Figi', value: 300, sigla2: 'FJ', sigla3: 'FJI', id: 'FJI' },
  { view: 'Finlandia', value: 20, sigla2: 'FI', sigla3: 'FIN', id: 'FIN' },
  { view: 'Francia', value: 20, sigla2: 'FR', sigla3: 'FRA', id: 'FRA' },
  {
    view: 'Guyana francese',
    value: 300,
    sigla2: 'GF',
    sigla3: 'GUF',
    id: 'GUF',
  },
  {
    view: 'Polinesia Francese',
    value: 300,
    sigla2: 'PF',
    sigla3: 'PYF',
    id: 'PYF',
  },
  { view: 'Gabon', value: 300, sigla2: 'GA', sigla3: 'GAB', id: 'GAB' },
  { view: 'Gambia', value: 300, sigla2: 'GM', sigla3: 'GMB', id: 'GMB' },
  { view: 'Georgia', value: 300, sigla2: 'GE', sigla3: 'GEO', id: 'GEO' },
  { view: 'Germania', value: 20, sigla2: 'DE', sigla3: 'DEU', id: 'DEU' },
  { view: 'Ghana', value: 300, sigla2: 'GH', sigla3: 'GHA', id: 'GHA' },
  { view: 'Gibilterra', value: 300, sigla2: 'GI', sigla3: 'GBZ', id: 'GBZ' },
  { view: 'Grecia', value: 20, sigla2: 'GR', sigla3: 'GRC', id: 'GRC' },
  { view: 'Groenlandia', value: 300, sigla2: 'GL', sigla3: 'GRL', id: 'GRL' },
  { view: 'Grenada', value: 300, sigla2: 'GD', sigla3: 'GRD', id: 'GRD' },
  { view: 'Guadalupa', value: 300, sigla2: 'GP', sigla3: 'GLP', id: 'GLP' },
  { view: 'Guam', value: 300, sigla2: 'GU', sigla3: 'GUM', id: 'GUM' },
  { view: 'Guatemala', value: 300, sigla2: 'GT', sigla3: 'GTM', id: 'GTM' },
  { view: 'Guernsey', value: 300, sigla2: 'GG', sigla3: 'GGY', id: 'GGY' },
  { view: 'Guinea', value: 300, sigla2: 'GN', sigla3: 'GIN', id: 'GIN' },
  { view: 'Guinea-Bissau', value: 300, sigla2: 'GW', sigla3: 'GNB', id: 'GNB' },
  { view: 'Guyana', value: 300, sigla2: 'GY', sigla3: 'GUY', id: 'GUY' },
  { view: 'Haiti', value: 300, sigla2: 'HT', sigla3: 'HTI', id: 'HTI' },
  { view: 'Honduras', value: 300, sigla2: 'HN', sigla3: 'HND', id: 'HND' },
  { view: 'Ungheria', value: 20, sigla2: 'HU', sigla3: 'HUN', id: 'HUN' },
  { view: 'Islanda', value: 50, sigla2: 'IS', sigla3: 'ISL', id: 'ISL' },
  { view: 'India', value: 300, sigla2: 'IN', sigla3: 'IND', id: 'IND' },
  { view: 'Indonesia', value: 300, sigla2: 'ID', sigla3: 'IDN', id: 'IDN' },
  { view: 'Iran', value: 300, sigla2: 'IR', sigla3: 'IRN', id: 'IRN' },
  { view: 'Iraq', value: 300, sigla2: 'IQ', sigla3: 'IRQ', id: 'IRQ' },
  { view: 'Irlanda', value: 20, sigla2: 'IE', sigla3: 'IRL', id: 'IRL' },
  { view: 'Isola di Man', value: 300, sigla2: 'IM', sigla3: 'IMN', id: 'IMN' },
  { view: 'Israele', value: 300, sigla2: 'IL', sigla3: 'ISR', id: 'ISR' },
  { view: 'Italia', value: 0, sigla2: 'IT', sigla3: 'ITA', id: 'ITA' },
  { view: 'Giamaica', value: 300, sigla2: 'JM', sigla3: 'JAM', id: 'JAM' },
  { view: 'Giappone', value: 50, sigla2: 'JP', sigla3: 'JPN', id: 'JPN' },
  { view: 'Jersey', value: 300, sigla2: 'JE', sigla3: 'JEY', id: 'JEY' },
  { view: 'Giordania', value: 300, sigla2: 'JO', sigla3: 'JOR', id: 'JOR' },
  { view: 'Kazakistan', value: 300, sigla2: 'KZ', sigla3: 'KAZ', id: 'KAZ' },
  { view: 'Kenya', value: 300, sigla2: 'KE', sigla3: 'KEN', id: 'KEN' },
  { view: 'Kiribati', value: 300, sigla2: 'KI', sigla3: 'KIR', id: 'KIR' },
  { view: 'Kuwait', value: 300, sigla2: 'KW', sigla3: 'KWT', id: 'KWT' },
  { view: 'Kyrgyzstan', value: 300, sigla2: 'KG', sigla3: 'KGZ', id: 'KGZ' },
  { view: 'Laos', value: 300, sigla2: 'LA', sigla3: 'LAO', id: 'LAO' },
  { view: 'Latvia', value: 20, sigla2: 'LV', sigla3: 'LVA', id: 'LVA' },
  { view: 'Lebanon', value: 300, sigla2: 'LB', sigla3: 'LBN', id: 'LBN' },
  { view: 'Lesotho', value: 300, sigla2: 'LS', sigla3: 'LSO', id: 'LSO' },
  { view: 'Liberia', value: 300, sigla2: 'LR', sigla3: 'LBR', id: 'LBR' },
  { view: 'Libya', value: 300, sigla2: 'LY', sigla3: 'LBY', id: 'LBY' },
  { view: 'Liechtenstein', value: 300, sigla2: 'LI', sigla3: 'LIE', id: 'LIE' },
  { view: 'Lithuania', value: 20, sigla2: 'LT', sigla3: 'LTU', id: 'LTU' },
  { view: 'Luxembourg', value: 20, sigla2: 'LU', sigla3: 'LUX', id: 'LUX' },
  { view: 'Madagascar', value: 300, sigla2: 'MG', sigla3: 'MDG', id: 'MDG' },
  { view: 'Malawi', value: 300, sigla2: 'MW', sigla3: 'MWI', id: 'MWI' },
  { view: 'Malaysia', value: 300, sigla2: 'MY', sigla3: 'MYS', id: 'MYS' },
  { view: 'Maldives', value: 300, sigla2: 'MV', sigla3: 'MDV', id: 'MDV' },
  { view: 'Mali', value: 300, sigla2: 'ML', sigla3: 'MLI', id: 'MLI' },
  { view: 'Malta', value: 20, sigla2: 'MT', sigla3: 'MLT', id: 'MLT' },
  {
    view: 'Marshall Islands',
    value: 300,
    sigla2: 'MH',
    sigla3: 'MHL',
    id: 'MHL',
  },
  { view: 'Martinique', value: 300, sigla2: 'MQ', sigla3: 'MTQ', id: 'MTQ' },
  { view: 'Mauritania', value: 300, sigla2: 'MR', sigla3: 'MRT', id: 'MRT' },
  { view: 'Mauritius', value: 300, sigla2: 'MU', sigla3: 'MUS', id: 'MUS' },
  { view: 'Mayotte', value: 300, sigla2: 'YT', sigla3: 'MYT', id: 'MYT' },
  { view: 'Mexico', value: 300, sigla2: 'MX', sigla3: 'MEX', id: 'MEX' },
  { view: 'Micronesia', value: 300, sigla2: 'FM', sigla3: 'FSM', id: 'FSM' },
  { view: 'Moldova', value: 300, sigla2: 'MD', sigla3: 'MDA', id: 'MDA' },
  { view: 'Monaco', value: 300, sigla2: 'MC', sigla3: 'MCO', id: 'MCO' },
  { view: 'Mongolia', value: 300, sigla2: 'MN', sigla3: 'MNG', id: 'MNG' },
  { view: 'Montenegro', value: 300, sigla2: 'ME', sigla3: 'MNE', id: 'MNE' },
  { view: 'Montserrat', value: 300, sigla2: 'MS', sigla3: 'MSR', id: 'MSR' },
  { view: 'Morocco', value: 300, sigla2: 'MA', sigla3: 'MAR', id: 'MAR' },
  { view: 'Mozambique', value: 300, sigla2: 'MZ', sigla3: 'MOZ', id: 'MOZ' },
  { view: 'Myanmar (Burma)', value: 300, sigla2: '', sigla3: 'SAS', id: 'SAS' },
  { view: 'Namibia', value: 300, sigla2: 'NA', sigla3: 'NAM', id: 'NAM' },
  { view: 'Nauru', value: 300, sigla2: 'NR', sigla3: 'NRU', id: 'NRU' },
  { view: 'Nepal', value: 300, sigla2: 'NP', sigla3: 'NPL', id: 'NPL' },
  { view: 'Netherlands', value: 20, sigla2: 'NL', sigla3: 'NLD', id: 'NLD' },
  { view: 'New Caledonia', value: 300, sigla2: 'NC', sigla3: 'NCL', id: 'NCL' },
  { view: 'New Zealand', value: 300, sigla2: 'NZ', sigla3: 'NZL', id: 'NZL' },
  { view: 'Nicaragua', value: 300, sigla2: 'NI', sigla3: 'NIC', id: 'NIC' },
  { view: 'Niger', value: 300, sigla2: 'NE', sigla3: 'NER', id: 'NER' },
  { view: 'Nigeria', value: 300, sigla2: 'NG', sigla3: 'NGA', id: 'NGA' },
  { view: 'Niue', value: 300, sigla2: 'NU', sigla3: 'NIU', id: 'NIU' },
  { view: 'North Korea', value: 300, sigla2: 'KP', sigla3: 'PRK', id: 'PRK' },
  {
    view: 'North Macedonia',
    value: 300,
    sigla2: 'MK',
    sigla3: 'MKD',
    id: 'MKD',
  },
  {
    view: 'Northern Mariana Islands',
    value: 300,
    sigla2: 'MP',
    sigla3: 'MNP',
    id: 'MNP',
  },
  { view: 'Norway', value: 50, sigla2: 'NO', sigla3: 'NOR', id: 'NOR' },
  { view: 'Oman', value: 300, sigla2: 'OM', sigla3: 'OMN', id: 'OMN' },
  { view: 'Pakistan', value: 300, sigla2: 'PK', sigla3: 'PAK', id: 'PAK' },
  { view: 'Palau', value: 300, sigla2: 'PW', sigla3: 'PLW', id: 'PLW' },
  { view: 'Palestine', value: 300, sigla2: 'PS', sigla3: 'PSE', id: 'PSE' },
  { view: 'Panama', value: 300, sigla2: 'PA', sigla3: 'PAN', id: 'PAN' },
  {
    view: 'Papua New Guinea',
    value: 300,
    sigla2: 'PG',
    sigla3: 'PNG',
    id: 'PNG',
  },
  { view: 'Paraguay', value: 300, sigla2: 'PY', sigla3: 'PRY', id: 'PRY' },
  { view: 'Perù', value: 300, sigla2: 'PE', sigla3: 'PER', id: 'PER' },
  { view: 'Filippine', value: 300, sigla2: 'PH', sigla3: 'PHL', id: 'PHL' },
  { view: 'Polonia', value: 20, sigla2: 'PL', sigla3: 'POL', id: 'POL' },
  { view: 'Portogallo', value: 20, sigla2: 'PT', sigla3: 'PRT', id: 'PRT' },
  { view: 'Puerto Rico', value: 300, sigla2: 'PR', sigla3: 'PRI', id: 'PRI' },
  { view: 'Qatar', value: 300, sigla2: 'QA', sigla3: 'QAT', id: 'QAT' },
  { view: 'Réunion', value: 300, sigla2: 'RE', sigla3: 'REU', id: 'REU' },
  { view: 'Romania', value: 20, sigla2: 'RO', sigla3: 'ROU', id: 'ROU' },
  { view: 'Russia', value: 300, sigla2: 'RU', sigla3: 'RUS', id: 'RUS' },
  { view: 'Rwanda', value: 300, sigla2: 'RW', sigla3: 'RWA', id: 'RWA' },
  { view: 'Saint Helena', value: 300, sigla2: 'SH', sigla3: 'SHN', id: 'SHN' },
  {
    view: 'Saint Kitts e Nevis',
    value: 300,
    sigla2: 'KN',
    sigla3: 'KNA',
    id: 'KNA',
  },
  { view: 'Saint Lucia', value: 300, sigla2: 'LC', sigla3: 'LCA', id: 'LCA' },
  {
    view: 'Saint-Pierre e Miquelon',
    value: 300,
    sigla2: 'PM',
    sigla3: 'SPM',
    id: 'SPM',
  },
  {
    view: 'Saint Vincent e Grenadine',
    value: 300,
    sigla2: 'VC',
    sigla3: 'VCT',
    id: 'VCT',
  },
  { view: 'Samoa', value: 300, sigla2: 'WS', sigla3: 'WSM', id: 'WSM' },
  { view: 'San Marino', value: 300, sigla2: 'SM', sigla3: 'SMR', id: 'SMR' },
  {
    view: 'São Tomé e Príncipe',
    value: 300,
    sigla2: 'ST',
    sigla3: 'STP',
    id: 'STP',
  },
  { view: 'Saudi Arabia', value: 300, sigla2: 'SA', sigla3: 'SAU', id: 'SAU' },
  { view: 'Senegal', value: 300, sigla2: 'SN', sigla3: 'SEN', id: 'SEN' },
  { view: 'Serbia', value: 300, sigla2: 'RS', sigla3: 'SRB', id: 'SRB' },
  { view: 'Seychelles', value: 300, sigla2: 'SC', sigla3: 'SYC', id: 'SYC' },
  { view: 'Sierra Leone', value: 300, sigla2: 'SL', sigla3: 'SLE', id: 'SLE' },
  { view: 'Singapore', value: 300, sigla2: 'SG', sigla3: 'SGP', id: 'SGP' },
  { view: 'Sint Maarten', value: 300, sigla2: 'SX', sigla3: 'SXM', id: 'SXM' },
  { view: 'Slovakia', value: 20, sigla2: 'SK', sigla3: 'SVK', id: 'SVK' },
  { view: 'Slovenia', value: 20, sigla2: 'SI', sigla3: 'SVN', id: 'SVN' },
  {
    view: 'Solomon Islands',
    value: 300,
    sigla2: 'SB',
    sigla3: 'SLB',
    id: 'SLB',
  },
  { view: 'Somalia', value: 300, sigla2: 'SO', sigla3: 'SOM', id: 'SOM' },
  { view: 'Sudafrica', value: 300, sigla2: 'ZA', sigla3: 'ZAF', id: 'ZAF' },
  { view: 'Corea del Sud', value: 300, sigla2: 'KR', sigla3: 'KOR', id: 'KOR' },
  { view: 'Sudan del Sud', value: 300, sigla2: 'SS', sigla3: 'SSD', id: 'SSD' },
  { view: 'Spagna', value: 20, sigla2: 'ES', sigla3: 'ESP', id: 'ESP' },
  { view: 'Sri Lanka', value: 300, sigla2: 'LK', sigla3: 'LKA', id: 'LKA' },
  { view: 'Sudan', value: 300, sigla2: 'SD', sigla3: 'SDN', id: 'SDN' },
  { view: 'Suriname', value: 300, sigla2: 'SR', sigla3: 'SUR', id: 'SUR' },
  { view: 'Svezia', value: 20, sigla2: 'SE', sigla3: 'SWE', id: 'SWE' },
  { view: 'Svizzera', value: 50, sigla2: 'CH', sigla3: 'CHE', id: 'CHE' },
  { view: 'Siria', value: 300, sigla2: 'SY', sigla3: 'SYR', id: 'SYR' },
  { view: 'Taiwan', value: 300, sigla2: 'TW', sigla3: 'TWN', id: 'TWN' },
  { view: 'Tagikistan', value: 300, sigla2: 'TJ', sigla3: 'TJK', id: 'TJK' },
  { view: 'Tanzania', value: 300, sigla2: 'TZ', sigla3: 'TZA', id: 'TZA' },
  { view: 'Thailandia', value: 300, sigla2: 'TH', sigla3: 'THA', id: 'THA' },
  { view: 'Timor Est', value: 300, sigla2: 'TL', sigla3: 'TLS', id: 'TLS' },
  { view: 'Togo', value: 300, sigla2: 'TG', sigla3: 'TGO', id: 'TGO' },
  { view: 'Tokelau', value: 300, sigla2: 'TK', sigla3: 'TKL', id: 'TKL' },
  { view: 'Tonga', value: 300, sigla2: 'TO', sigla3: 'TON', id: 'TON' },
  {
    view: 'Trinidad e Tobago',
    value: 300,
    sigla2: 'TT',
    sigla3: 'TTO',
    id: 'TTO',
  },
  { view: 'Tunisia', value: 300, sigla2: 'TN', sigla3: 'TUN', id: 'TUN' },
  { view: 'Turchia', value: 300, sigla2: 'TR', sigla3: 'TUR', id: 'TUR' },
  { view: 'Turkmenistan', value: 300, sigla2: 'TM', sigla3: 'TKM', id: 'TKM' },
  {
    view: 'Turks e Caicos',
    value: 300,
    sigla2: 'TC',
    sigla3: 'TCA',
    id: 'TCA',
  },
  { view: 'Tuvalu', value: 300, sigla2: 'TV', sigla3: 'TUV', id: 'TUV' },
  {
    view: 'Isole Vergini Americane',
    value: 300,
    sigla2: 'VI',
    sigla3: 'VIR',
    id: 'VIR',
  },
  { view: 'Uganda', value: 300, sigla2: 'UG', sigla3: 'UGA', id: 'UGA' },
  { view: 'Ucraina', value: 300, sigla2: 'UA', sigla3: 'UKR', id: 'UKR' },
  {
    view: 'Emirati Arabi Uniti',
    value: 300,
    sigla2: 'AE',
    sigla3: 'ARE',
    id: 'ARE',
  },
  { view: 'Regno Unito', value: 50, sigla2: 'GB', sigla3: 'GBR', id: 'GBR' },
  {
    view: "Stati Uniti d'America",
    value: 50,
    sigla2: 'US',
    sigla3: 'USA',
    id: 'USA',
  },
  { view: 'Uruguay', value: 300, sigla2: 'UY', sigla3: 'URY', id: 'URY' },
  { view: 'Uzbekistan', value: 300, sigla2: 'UZ', sigla3: 'UZB', id: 'UZB' },
  { view: 'Vanuatu', value: 300, sigla2: 'VU', sigla3: 'VUT', id: 'VUT' },
  {
    view: 'Città del Vaticano',
    value: 300,
    sigla2: 'VA',
    sigla3: 'VAT',
    id: 'VAT',
  },
  { view: 'Venezuela', value: 300, sigla2: 'VE', sigla3: 'VEN', id: 'VEN' },
  { view: 'Vietnam', value: 300, sigla2: 'VN', sigla3: 'VNM', id: 'VNM' },
  {
    view: 'Wallis e Futuna',
    value: 300,
    sigla2: 'WF',
    sigla3: 'WLF',
    id: 'WLF',
  },
  {
    view: 'Sahara occidentale',
    value: 300,
    sigla2: undefined,
    sigla3: 'SAS',
    id: 'SAS',
  },
  { view: 'Yemen', value: 300, sigla2: 'YE', sigla3: 'YEM', id: 'YEM' },
  { view: 'Zambia', value: 300, sigla2: 'ZM', sigla3: 'ZMB', id: 'ZMB' },
  { view: 'Zimbabwe', value: 300, sigla2: 'ZW', sigla3: 'ZWE', id: 'ZWE' },
];

export const getCountriesOptions = () => {
  let options: SfSelectOption<string>[] = COUNTRIES.map((country) => ({
    value: country.sigla3,
    view: country.view,
  }));

  return options;
};
